import { FormFieldWidget, ModelFieldType, SPI, ViewType } from '@kunlun/dependencies';
import { RemoveZeroFormFloatFieldWidget } from './RemoveZeroFormFloatFieldWidget';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Form, ViewType.Search],
    ttype: ModelFieldType.Currency
  })
)
export class RemoveZeroFormMoneyFieldWidget extends RemoveZeroFormFloatFieldWidget {
  public initialize(props) {
    super.initialize(props);
    return this;
  }
}
